// Real projects led by the founder, Tabrez Dal.
// Each `url` opens the full write-up on his portfolio (tabrezdal.com).
const CaseStudyData = [
  {
    title: "MyCricle",
    role: "Sole Principal Designer + Primary Frontend Developer",
    year: "2023",
    description:
      "White-label hospitality SaaS unifying guest WiFi, multi-channel marketing, loyalty, and POS — 253 screens across 10 modules and 3 repositories, built solo over 6–7 months for a Canadian direct client.",
    tags: ["White-label SaaS", "Design System", "React 18", "GraphQL"],
    url: "https://tabrezdal.com/case-study/mycricle/",
  },
  {
    title: "IEHP Care Manager Maintenance",
    role: "Sole Product Designer + Frontend Developer (Angular)",
    year: "2023",
    description:
      "Internal enterprise platform managing 30,000+ care plan assignments across 35 care managers in 4 California regions — replacing fragmented manual processes with a single data-dense command centre. 62 screens, shipped to production, designed and built solo.",
    tags: ["Healthcare", "Enterprise", "Dashboard", "Angular"],
    url: "https://tabrezdal.com/case-study/iehp-cmm/",
  },
  {
    title: "IEHP Healthcare Scholarship Fund",
    role: "Product Designer (Contractor)",
    year: "2023",
    description:
      "Dual-interface platform managing IEHP's medical scholarship programme for 500 scholars across 4 universities. 77 screens, WCAG compliant, externally reviewed by IEHP's senior designer, and shipped to production.",
    tags: ["Healthcare", "WCAG", "Enterprise"],
    url: "https://tabrezdal.com/case-study/iehp-hsf/",
  },
  {
    title: "EdXplore Admin Panel",
    role: "Admin Panel Designer + Frontend Engineering Lead",
    year: "2023",
    description:
      "Sole designer (93 screens) and frontend engineering lead (5 junior developers) for a multi-portal EdTech platform — 4-role RBAC, 8-step institute onboarding wizard, 5-state content lifecycle, and B2B SaaS billing.",
    tags: ["EdTech", "B2B SaaS", "Engineering Lead", "React 18"],
    url: "https://tabrezdal.com/case-study/edxplore/",
  },
  {
    title: "JobzShala",
    role: "Sole Product Designer + Engineering Contributor",
    year: "2024",
    description:
      "Six interconnected recruitment portals — job seekers, employers, campus students, college admins, staffing agencies, and enterprise ATS — sharing one design system. 240+ screens over 8 months, all live.",
    tags: ["HR Tech", "Multi-portal", "Design System", "React/Next.js"],
    url: "https://tabrezdal.com/case-study/jobzshala/",
  },
  {
    title: "ASIN Vault",
    role: "Solo UX Designer + Frontend Engineer",
    year: "2024",
    description:
      "Amazon seller analytics Chrome extension — brand identity, design system, 14 screens, and a complete HTML/CSS/JS frontend, designed and built solo for a London client. Published commercially to the Chrome Web Store.",
    tags: ["Chrome Extension", "Amazon FBA", "UK client"],
    url: "https://tabrezdal.com/case-study/asin-vault/",
  },
];

export default CaseStudyData;
